<template>
  <page-container title="Warehouse">
    <v-row class="ma-0 mb-2 pa-2 header" align-content="center">
      <v-tabs v-model="selectedTab" height="36">
        <v-tab :to="{ name: 'warehouse-stock', dataPath: 'materials' }"
          >Stock</v-tab
        >

        <v-tab :to="{ name: 'stock-categories', dataPath: 'categories' }"
          >Categories</v-tab
        >
        <v-tab :to="{ name: 'warehouse-locations', dataPath: 'locations' }"
          >Locations</v-tab
        >
        <v-spacer></v-spacer>
        <search-field></search-field>
        <feature name="warehouse" variant="write" :data="collectionName">
          <v-btn
            color="primary"
            class="button"
            tile
            @click.prevent="showNewTableItemPopup"
          >
            {{ actionTitle }}
          </v-btn>
        </feature>
      </v-tabs>
    </v-row>
    <router-view></router-view>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import SearchField from '@/components/SearchField.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Warehouse',
  components: {
    PageContainer,
    SearchField,
  },
  data() {
    return {
      selectedTab: 0,
    }
  },
  computed: {
    actionTitle() {
      switch (this.$route.name) {
      case 'stock-categories':
        return 'New category'
      case 'warehouse-locations':
        return 'New location'
      default:
        return 'New item'
      }
    },
    collectionName() {
      switch (this.selectedTab) {
      case 0:
        return 'materials'
      case 1:
        return 'categories'
      case 2:
        return 'locations'
      default:
        return ''
      }
    },
  },
  methods: {
    ...mapActions(['showNewTableItemPopup']),
  },
}
</script>

<style lang="sass" scoped>
.header
  background-color: $foreground
  height: 58px
</style>
